import { Box, Button } from '@factorialco/deprecated-design-system'
import { FinanceValueObjectsTaxSourceEnum } from 'generated/resources/graphql'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

interface ActionsProps {
  source: FinanceValueObjectsTaxSourceEnum
  onShowEditClick: () => void
  onShowDetailClick: () => void
  onShowDeleteClick: () => void
}

interface PopoverProps {
  source: FinanceValueObjectsTaxSourceEnum
  onShowEditClick: () => void
  onShowDeleteClick: () => void
}

const Popover = ({ source, onShowEditClick, onShowDeleteClick }: PopoverProps) => {
  const actions = () => {
    return (
      <>
        <PopoverMenu.TouchableOption onClick={onShowEditClick} title={i18n.t('common.edit')} />
        {source === 'custom' && (
          <PopoverMenu.TouchableOption
            onClick={onShowDeleteClick}
            title={i18n.t('common.delete')}
            danger
          />
        )}
      </>
    )
  }

  return (
    <PopoverMenu type="list">
      <PopoverMenu.Trigger>
        <Button.Decorative type="secondary" iconName="ellipsis" />
      </PopoverMenu.Trigger>
      <PopoverMenu.Content side="bottom" align="end">
        {actions()}
      </PopoverMenu.Content>
    </PopoverMenu>
  )
}

const Actions = ({
  source,
  onShowEditClick,
  onShowDetailClick,
  onShowDeleteClick,
}: ActionsProps) => {
  return (
    <Box gap="s4" flexDirection="row" justifyContent="flexEnd">
      <Popover
        source={source}
        onShowEditClick={onShowEditClick}
        onShowDeleteClick={onShowDeleteClick}
      />
      <Button type="secondary" iconName="arrow-right" onClick={onShowDetailClick} />
    </Box>
  )
}

export default Actions
